import {
  CampaignPayload,
  campaignPayloadSchema,
  CampaignSchema,
} from '../schemas/campaign';

export const campaignFromPayload = (campaignPayload: CampaignPayload) => {
  const validatedCampaignPayload = campaignPayloadSchema.parse(campaignPayload);

  const builtCampaign: CampaignSchema = {
    id: validatedCampaignPayload.id,
    name: validatedCampaignPayload.name,
    startDate: validatedCampaignPayload.start_date,
    endDate: validatedCampaignPayload.end_date,
    lciVersionId: validatedCampaignPayload.lci_version_id,
    measurementStatus: validatedCampaignPayload.measurement_status,
    budget: validatedCampaignPayload.budget,
    adSpend: validatedCampaignPayload.ad_spend ?? undefined,
    latestReportUpdatedDate:
      validatedCampaignPayload.latest_report_updated_date ?? '',
    latestStatDate: validatedCampaignPayload.latest_stat_date ?? '',
    salesLiftEnabled: validatedCampaignPayload.lci_sales_lift_flag,
    salesLiftRequested: validatedCampaignPayload.sales_attribution_requested,
  };

  return builtCampaign;
};
